import DepreciationClassForm from './DepreciationClassForm'
export default DepreciationClassForm
